module.exports = __webpack_public_path__ + "img/logo-white.c6083cd2.png";